import { get, post, put, del, type ApiResponse } from '@/utils/request';

/** 获取权限列表 GET /api/admin/permissions */
export async function getPermissionList(
    params: {
        page?: number;
        pageSize?: number;
        permissionType?: string;
        permissionCode?: string;
        status?: number;
    },
    options?: { skipErrorHandler?: boolean },
): Promise<ApiResponse<API.PermissionListResponse>> {
    return get<API.PermissionListResponse>('/api/admin/permissions', params, options);
}

/** 创建权限 POST /api/admin/permissions */
export async function createPermission(
    body: API.PermissionCreateRequest,
    options?: { skipErrorHandler?: boolean },
): Promise<ApiResponse<API.PermissionInfo>> {
    return post<API.PermissionInfo>('/api/admin/permissions', body, options);
}

/** 更新权限 PUT /api/admin/permissions/{permissionId} */
export async function updatePermission(
    permissionId: number,
    body: API.PermissionUpdateRequest,
    options?: { skipErrorHandler?: boolean },
): Promise<ApiResponse<API.PermissionInfo>> {
    return put<API.PermissionInfo>(`/api/admin/permissions/${permissionId}`, body, options);
}

/** 删除权限 DELETE /api/admin/permissions/{permissionId} */
export async function deletePermission(
    permissionId: number,
    options?: { skipErrorHandler?: boolean },
): Promise<ApiResponse<any>> {
    return del<any>(`/api/admin/permissions/${permissionId}`, options);
}

/** 获取权限树 GET /api/admin/permissions/tree */
export async function getPermissionTree(
    options?: { skipErrorHandler?: boolean },
): Promise<ApiResponse<API.PermissionInfo[]>> {
    return get<API.PermissionInfo[]>('/api/admin/permissions/tree', undefined, options);
}

/** 获取当前管理员的权限列表 GET /api/admin/permissions/my */
export async function getMyPermissions(
    options?: { skipErrorHandler?: boolean },
): Promise<ApiResponse<API.PermissionInfo[]>> {
    return get<API.PermissionInfo[]>('/api/admin/permissions/my', undefined, options);
}
